import * as Immutable from 'immutable';
import {
  SET_SELECTED_PLANOWNER_REQUESTED,
  SET_SELECTED_PLANOWNER_COMPLETED,
  SET_INITIAL_PLAN_REQUESTED,
  SET_INITIAL_PLAN_COMPLETED,
  RESET_INITIAL_PLAN_COMPLETED,
  SET_SELECTED_PLAN_REQUESTED,
  SET_SELECTED_PLAN_COMPLETED,
  RESET_SELECTED_PLAN_REQUESTED,
  RESET_SELECTED_PLAN_COMPLETED,
  SET_SELECTED_SUBPLAN_REQUESTED,
  SET_SELECTED_SUBPLAN_COMPLETED,
  RESET_SELECTED_SUBPLAN_REQUESTED,
  RESET_SELECTED_SUBPLAN_COMPLETED,
  CHANGE_SELECTED_PLAN_REQUESTED,
  CHANGE_SELECTED_PLAN_COMPLETED,
  RESET_SELECTED_REQUESTED,
  RESET_SELECTED_COMPLETED,
} from '../../actions/selected/types';

const schema = {
  status: 'INIT', // INIT/OK/ERROR
  error: null,
  planowner: {},
  plan: {},
  subplan: {},
  changingplan: {},
  initialplan: {},
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_PLANOWNER_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case SET_SELECTED_PLANOWNER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('planowner', action.payload);

    case SET_SELECTED_PLAN_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case SET_SELECTED_PLAN_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('changingplan', {})
        .set('plan', action.payload);

    case SET_SELECTED_SUBPLAN_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case SET_SELECTED_SUBPLAN_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('changingplan', {})
        .set('subplan', action.payload);

    case RESET_SELECTED_SUBPLAN_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case RESET_SELECTED_SUBPLAN_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('changingplan', {})
        .set('subplan', {});

    case RESET_SELECTED_PLAN_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_SELECTED_PLAN_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('plan', {})
        .set('gotdata', false);

    case CHANGE_SELECTED_PLAN_REQUESTED:
      return state.set('changingplan', {});

    case CHANGE_SELECTED_PLAN_COMPLETED:
      return state.set('changingplan', action.payload);

    case SET_INITIAL_PLAN_REQUESTED:
      return state.set('initialplan', {});

    case SET_INITIAL_PLAN_COMPLETED:
      return state.set('initialplan', action.payload);

    case RESET_INITIAL_PLAN_COMPLETED:
      return state.set('initialplan', {});

    case RESET_SELECTED_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_SELECTED_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('planowner', {})
        .set('gotdata', false);
    default:
      return state;
  }
};

export { initialState };

export default reducer;
